/**
 * Tracks whether a Director chat tool call (render_video, generate_brief,
 * generate_storyboard, …) is actively streaming.
 *
 * The build-version watcher (`useBuildVersionReload`) force-reloads the page
 * when a new deploy is detected mid-session. With frequent deploys that
 * reload can land in the middle of an in-flight render, severing the stream
 * before the tool result arrives — surfacing as "The browser reloaded before
 * it received this tool result" and stranding partial progress. This flag
 * lets the watcher DEFER a proactive reload while a tool is running; it never
 * blocks the reactive error-recovery reload path.
 *
 * A freshness cap bounds a wedged flag so a stuck stream can't block reloads
 * forever — once it lapses, the next deploy reload proceeds normally.
 */
// Must cover the LONGEST legitimate single tool window, or the deploy reload
// fires mid-tool exactly when it hurts most: the render poll loop allows 30
// minutes and the storyboard loop 45, while the in-flight flag is only set
// once when streaming starts (one long tool = one uninterrupted window).
const MAX_INFLIGHT_MS = 45 * 60_000;

let inFlightSince: number | null = null;

export function setDirectorToolInFlight(active: boolean): void {
  inFlightSince = active ? Date.now() : null;
}

export function isDirectorToolInFlight(): boolean {
  if (inFlightSince === null) return false;
  if (Date.now() - inFlightSince > MAX_INFLIGHT_MS) {
    inFlightSince = null;
    return false;
  }
  return true;
}
